import React from "react";
import CountUp from "react-countup";
import { useInView } from "../Hooks/useInView";
import styles from "./StatsSection.module.css";

const stats = [
  { end: 20, suffix: "+", label: "Jahre Erfahrung", prefix: "" },
  { end: 2100, suffix: "+", separator: ".", label: "Wohn- und Gewerbeinheiten", prefix: "" },
  {
    end: 149,
    suffix: (
      <>
        .000&nbsp;m
        <sup className={styles.superscript}>2</sup>
      </>
    ),
    decimals: 0,
    label: "Wohn-/Gewerbefläche",
    prefix: "",
  },
];

const StatsSection: React.FC = () => {
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 960;

  const [ref, inView] = useInView<HTMLDivElement>(0.4);

  const mobileRefs = stats.map(() => useInView<HTMLDivElement>(0.08));

  return (
    <section className={styles.statsSection} ref={!isMobile ? ref : undefined}>
      <div className={styles.container}>
        {stats.map((stat, i) => (
          <div
            key={i}
            className={styles.statBox}
            ref={isMobile ? mobileRefs[i][0] : undefined}
          >
            <span className={styles.statNumber}>
              {stat.prefix}
              {(isMobile ? mobileRefs[i][1] : inView) && (
                <CountUp
                  end={stat.end}
                  duration={2.5}
                  separator={stat.separator}
                  decimals={stat.decimals}
                />
              )}
              {typeof stat.suffix === "string" ? stat.suffix : stat.suffix}
            </span>
            <span className={styles.statLabel}>{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
